export default "__VITE_ASSET__2b218bf0__"